var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _c(
      "h3",
      { staticClass: "title", attrs: { content: "edit", placement: "bottom" } },
      [
        _vm._v("\n    Notification Management\n    "),
        _vm.$store.state.userLevel == 1
          ? _c(
              "el-button",
              {
                staticStyle: { width: "180px" },
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.handleAdd()
                  }
                }
              },
              [_vm._v("Create")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "search-toggle",
            on: {
              click: function($event) {
                _vm.searchExpanded = !_vm.searchExpanded
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.searchExpanded ? "Hide Filters" : "Show Filters") +
                "\n      "
            ),
            _c("em", {
              staticClass: "el-icon-arrow-up",
              class: { "is-collapsed": !_vm.searchExpanded }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.searchExpanded,
            expression: "searchExpanded"
          }
        ],
        staticClass: "searchBox"
      },
      [
        _c(
          "el-form",
          {
            ref: "formInline",
            staticClass: "demo-form-inline",
            attrs: { model: _vm.formInline }
          },
          [
            _c(
              "div",
              { staticClass: "search-grid" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "title" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Title", maxlength: "50" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.title,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "title", $$v)
                        },
                        expression: "formInline.title"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "category" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "Notification Category",
                        maxlength: "50"
                      },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.submitSearch.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.formInline.category,
                        callback: function($$v) {
                          _vm.$set(_vm.formInline, "category", $$v)
                        },
                        expression: "formInline.category"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "search-toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__actions" },
            [
              _c(
                "el-button",
                {
                  staticClass: "search",
                  attrs: { type: "primary" },
                  on: { click: _vm.submitSearch }
                },
                [_vm._v("Search")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset",
                  on: {
                    click: function($event) {
                      return _vm.resetForm("formInline")
                    }
                  }
                },
                [_vm._v("Reset")]
              )
            ],
            1
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "client-panel" },
      [
        _c("div", { staticClass: "client-panel__toolbar" }, [
          _c(
            "div",
            { staticClass: "search-toolbar__extra" },
            [
              _c("columns-control", {
                attrs: {
                  columns: _vm.columnsConfig,
                  "storage-key": "cms.notificationManagement.columns"
                },
                on: { change: _vm.onColumnsChange }
              }),
              _vm._v(" "),
              _c(
                "el-dropdown",
                { ref: "filter", attrs: { trigger: "click" } },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "filter" }),
                    _vm._v("\n          Filter\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formFilter",
                          staticStyle: { width: "300px", padding: "14px 24px" },
                          attrs: { model: _vm.formFilter }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Notification Type",
                                prop: "type"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "type", $$v)
                                    },
                                    expression: "formFilter.type"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "System Updates",
                                      value: "SYSTEM"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Investment Updates",
                                      value: "INVESTMENT"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Corporate Updates",
                                      value: "CORPORATE"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "Market Updates",
                                      value: "MARKET"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: {
                                label: "Sales Office",
                                prop: "salesOffice"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    "popper-append-to-body": false,
                                    disabled: _vm.$store.state.userLevel >= 2
                                  },
                                  on: { change: _vm.changeSalesOffice },
                                  model: {
                                    value: _vm.formFilter.salesOffice,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formFilter,
                                        "salesOffice",
                                        $$v
                                      )
                                    },
                                    expression: "formFilter.salesOffice"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.salesOfficeList, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "12px" },
                              attrs: { label: "Region", prop: "region" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { "popper-append-to-body": false },
                                  model: {
                                    value: _vm.formFilter.region,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formFilter, "region", $$v)
                                    },
                                    expression: "formFilter.region"
                                  }
                                },
                                [
                                  _c("el-option", { attrs: { value: "All" } }, [
                                    _vm._v("All")
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.regionList, function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "filterButton" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: {
                                    "margin-right": "15px",
                                    "margin-bottom": "0"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "reset",
                                      on: {
                                        click: function($event) {
                                          _vm.$refs.filter.hide()
                                          _vm.resetForm("formFilter")
                                        }
                                      }
                                    },
                                    [_vm._v("Reset")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "search",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function() {
                                          _vm.$refs.filter.hide()
                                          _vm.submitSearch()
                                        }
                                      }
                                    },
                                    [_vm._v("Apply")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click" },
                  on: { command: _vm.handleCommand }
                },
                [
                  _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                    _c("em", { staticClass: "sort" }),
                    _vm._v("\n          Sort by\n        ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: ["updatedAt,desc", "notificationId,Desc"]
                          }
                        },
                        [_vm._v("Last update date (New - Old)")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: ["updatedAt,asc", "notificationId,Desc"]
                          }
                        },
                        [_vm._v("Last update date (Old - New)")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "el-table",
          { attrs: { data: _vm.tableData } },
          [
            _vm.isColumnVisible("notificationId")
              ? _c("el-table-column", {
                  attrs: { label: "Notification ID", prop: "notificationId" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("type")
              ? _c("el-table-column", {
                  attrs: { label: "Notification Type" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.$commonjs.pushTypeMap(scope.row.type))
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    486966368
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("category")
              ? _c("el-table-column", {
                  attrs: { label: "Notification Category", prop: "category" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("salesOffice")
              ? _c("el-table-column", {
                  attrs: { label: "Sales Office" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.salesOfficeMap(
                                  scope.row.salesOffice
                                )
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4066695550
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("region")
              ? _c("el-table-column", {
                  attrs: { label: "Region" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.handleTableRegion(scope.row.regions))
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1535390011
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("title")
              ? _c("el-table-column", {
                  attrs: { prop: "titles.EN", label: "Title" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("deliveryDate")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "deliveryDate",
                    label: "Delivery Date & Time",
                    formatter: _vm.$commonjs.tableFormatDateTime
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("status")
              ? _c("el-table-column", {
                  attrs: { label: "Status" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                style:
                                  scope.row.status == "PENDING"
                                    ? "color:rgb(85,130,160)"
                                    : scope.row.status == "DELIVERED"
                                    ? "color:rgb(0,127,80)"
                                    : "color:rgb(255,0,0)"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$commonjs.pushStatusMap(
                                      scope.row.status
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    4143472705
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isColumnVisible("updatedAt")
              ? _c("el-table-column", {
                  attrs: {
                    prop: "updatedAt",
                    label: "Last update",
                    formatter: _vm.$commonjs.tableFormatDateTime
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Operation" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "btnFlex" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "Edit",
                                placement: "top"
                              }
                            },
                            [
                              _c("em", {
                                staticClass: "edit",
                                staticStyle: { "margin-right": "10px" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(scope.row)
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          scope.row.status != "REVOKED_PENDING" &&
                          scope.row.status != "REVOKED_DELIVERED"
                            ? _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "Revoke",
                                    placement: "top"
                                  }
                                },
                                [
                                  _c("em", {
                                    staticClass: "revoke",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleRevoke(scope.row)
                                      }
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.handleAddClone(scope.row)
                                }
                              }
                            },
                            [_vm._v("Clone")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("app-pagination", {
          attrs: {
            "current-page": _vm.currentPage,
            "page-sizes": [5, 10, 20, 50],
            total: _vm.total,
            "page-size": _vm.currentSize
          },
          on: {
            "size-change": function(v) {
              _vm.currentSize = v
              _vm.currentPage = 1
              _vm.getList()
            },
            "current-change": function(v) {
              _vm.currentPage = v
              _vm.getList()
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5c2bfa2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5c2bfa2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification/notification.vue
// module id = null
// module chunks = 